import { ExtraBreakpointDiv } from './Styled'

export const SectionDiv = (props) => {
  let height, breakpointHeight

  if (props.length > 30) {
    height = ['700px', '350px', '300px']
    breakpointHeight = '1300px'
  } else if (props.length > 18) {
    height = ['280px', '190px', '150px']
    breakpointHeight = '500px'
  } else {
    height = ['160px', '100px', '100px']
    breakpointHeight = '300px'
  }

  return <ExtraBreakpointDiv height={height} breakpointHeight={breakpointHeight} {...props} />
}

export default SectionDiv
